<div
  class="text-right mb-3"
  *ngIf="isExpand"
  [ngClass]="
    alayticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''
  "
>
  <button class="btn-close" (click)="closeExpandView()">
    <nb-icon
      icon="collapse"
      class="icon-close-expand-view cursor-pointer"
    ></nb-icon>
  </button>
</div>
<div
  [ngClass]="
    alayticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''
  "
>
  <nb-tabset class="{{ isExpand ? '' : 'presentation-source-tab-set' }}">
    <nb-tab tabTitle="Overall Academic Performance" [lazyLoad]="true">
      <div class="chart-container">
        <div class="period-select d-flex justify-content-between"></div>
        <div class="tooltip-container">
          <ngx-chart
            #profitChart
            [currentUser]="currentUser"
            [isExpand]="isExpand"
          ></ngx-chart>
        </div>
      </div>
    </nb-tab>
    <nb-tab tabTitle="Platform Usage">
      <div class="chart-container">
        <ngx-performance-usage-chart
          #ordersChart
          [currentUser]="currentUser"
        ></ngx-performance-usage-chart>
      </div>
    </nb-tab>
  </nb-tabset>
</div>
